module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_5.8e5b22ff.png";